import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@unbridaled/ui-components'
import { DiamondsTable } from 'lib/components/diamondsTable'
import { ConfirmationModalProps, ConfirmationModalContentProps } from 'types/interfaces'
import {
  ResponsiveModal,
  ResponsiveModalContent,
  ResponsiveModalFooterDesktop,
  ResponsiveModalHeaderDesktop,
  ResponsiveModalHeaderMobile
} from '../ResponsiveModal/ResponsiveModal'
import { ResponsiveModalProps } from '@unbridaled/ui-components/ResponsiveModal'

export const ModalContent: React.FC<ConfirmationModalContentProps> = ({
  gems,
  orderType,
  config,
  stoneType = "diamond",
}) => {
  const { t } = useTranslation()
  const orderTypeName = orderType === 'm' ? t('common.memo') : t('common.invoice')

  return (
    <div className="unbridaled-confirmation-content-wrapper">
      <div className="unbridaled-diamond-data diamond-data">
        <div className="unbridaled-header-row header-row">
          <span>
            {t('confirmationModal.confirmPromptPrefix')}{' '}
            <b>
              <i>{orderTypeName}</i>
            </b>{' '}
            {t('confirmationModal.confirmPromptSuffix', { stoneType, context: stoneType })}
          </span>
        </div>
        <DiamondsTable
          selectedDiamonds={gems}
          sourceTypes={config.sourceTypes}
          stoneType={stoneType}
        />
      </div>
    </div>
  )
}

export type ModalProps = ConfirmationModalProps & ResponsiveModalProps

export const ConfirmationModal = ({
  open,
  gems,
  orderType,
  config,
  stoneType = "diamond",
  onClose,
  onConfirm,
  ...props
}: ModalProps): React.ReactNode => {

  const { t } = useTranslation()
  const handleClose = (): void => {
    onClose()
  }
  const confirmBtnText =
    orderType === 'm'
      ? t('confirmationModal.confirmMemoBtn')
      : t('confirmationModal.invoiceBtn', { stoneType, context: stoneType })

  return (
    <ResponsiveModal size="uui-w-[70%] uui-max-w-2xl" {...props} onClose={handleClose} open={open}>
      <ResponsiveModalHeaderDesktop title={t('common.confirm', 'Confirm')} onClose={handleClose} />
      <ResponsiveModalHeaderMobile
        title={t('common.confirm', 'Confirm')}
        trailingIcon={
          <Button className="uui-flex-1 mobile-modal-button uui-justify-end unbridaled-submit" onClick={onConfirm}>
            {confirmBtnText}
          </Button>
        }
        leadingIcon={
          <Button className="uui-flex-1 mobile-modal-button uui-justify-start unbridaled-cancel" onClick={handleClose}>
            {t('common.cancel')}
          </Button>
        }
      />
      <ResponsiveModalContent>
        <ModalContent
          gems={gems}
          orderType={orderType}
          config={config}
          stoneType={stoneType}
        />
      </ResponsiveModalContent>
      <ResponsiveModalFooterDesktop>
        <Button className="uui-flex-1 unbridaled-submit" onClick={onConfirm}>
          {confirmBtnText}
        </Button>
      </ResponsiveModalFooterDesktop>
    </ResponsiveModal>
  )
}